import { IApplicationState } from '../../types/redux';

export function getNewbuildingOfferType(state: IApplicationState) {
  return state.newbuilding.offerTypes;
}
